import { CitySearchSuggestion } from '@city/const';
import { StateUtils } from '@spartacus/core';
import { CITY_SEARCH } from '../city-state';

export const CITY_SEARCH_LOAD = '[CustomUser] City Search Load';
export const CITY_SEARCH_SUCCESS = '[CustomUser] City Search Load Success';
export const CITY_SEARCH_FAIL = '[CustomUser] City Search Load Fail';
export const CITY_SEARCH_RESET = '[CustomUser] City Search Reset';

export class CitySearch extends StateUtils.LoaderLoadAction {
  readonly type = CITY_SEARCH_LOAD;

  constructor(public payload: string) {
    super(CITY_SEARCH);
  }
}

export class CitySearchFail extends StateUtils.LoaderFailAction {
  readonly type = CITY_SEARCH_FAIL;

  constructor(public payload: any) {
    super(CITY_SEARCH, payload);
  }
}

export class CitySearchSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CITY_SEARCH_SUCCESS;

  constructor(public payload: CitySearchSuggestion[]) {
    super(CITY_SEARCH);
  }
}

export class CitySearchReset extends StateUtils.LoaderResetAction {
  readonly type = CITY_SEARCH_RESET;

  constructor() {
    super(CITY_SEARCH);
  }
}

// action types
export type CitySearchAction = CitySearch | CitySearchSuccess | CitySearchFail | CitySearchReset;
